export const mapObject = (obj: {}, cb: Function) => {
  if (!obj) return {};
  return Object.fromEntries(Object.entries(obj).map(([k, v]) => [k, cb(v)]));
};
